<template>
  <div class="shoppe">
    <div class="query-form">
      <el-form label-position="right" label-width="60px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="18" :lg="20" :xl="22">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
                <el-form-item label="用户ID">
                  <el-input v-model.trim="queryForm.appUserId" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
                <el-form-item label="手机号">
                  <el-input v-model.trim="queryForm.mobile" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col v-if="activeTab === '2'" :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
                <el-form-item label="店铺名称" label-width="80px">
                  <el-input v-model.trim="queryForm.vendorName" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="6" :lg="4" :xl="2">
            <el-button @click="search" type="primary">查询</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-tabs v-model="activeTab" type='card' @tab-click="handleClick">
      <el-tab-pane label="待审核" name="1"></el-tab-pane>
      <el-tab-pane label="已审核通过" name="2"></el-tab-pane>
      <el-tab-pane label="已拒绝" name="3"></el-tab-pane>
    </el-tabs>
    <div class="mt10">
      <el-button @click="exportFile" type="primary">导出</el-button>
    </div>
    <SettleTable :curr-status="activeTab" ref='table' :queryForm='queryForm'></SettleTable>
  </div>
</template>

<script>
import { exportSeller } from './api';
import SettleTable from './settleTable.vue'
export default {
  data() {
    return {
      activeTab: '1',
      queryForm: {
        appUserId: null,
        mobile: null,
        vendorId: null,
      },
    };
  },
  components: {
    SettleTable,
  },
  mounted() {
  },
  methods: {
    handleClick(tab) {
      this.queryForm.appUserId = null;
      this.queryForm.mobile = null;
      this.queryForm.vendorId = null;
      this.activeTab = tab.name;
      this.$nextTick(() => {
        this.$refs.table.getTableData(true)
      })
    },
    search() {
      this.$refs.table.getTableData(true)
    },
    exportFile() {
      exportSeller({
        status: this.activeTab,
      }).then(res => {
        const blob = res.data;
        const xlsxNameMap = {
          1: '待审核.xlsx',
          2: '已审核通过.xlsx',
          3: '已拒绝.xlsx',
        };
        this.downloadFile(blob, xlsxNameMap[this.activeTab]);
      })
    },
    downloadFile(blob, fileName) {
      if ("download" in document.createElement("a")) {
        // 非IE下载
        const elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      } else {
        // IE10+下载
        navigator.msSaveBlob(blob, fileName);
      }
    },
  }
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
</style>
